/**
 * ImpactChangedContent - Renders content for ImpactChanged timeline events
 * Shows old and new impact values
 */

import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface ImpactChangedContentProps {
  event: TimelineEvent;
}

const ImpactChangedContent: React.FC<ImpactChangedContentProps> = ({ event }) => {
  const { t } = useTranslation();

  const oldImpact = event.payload?.oldImpact ?? '';
  const newImpact = event.payload?.newImpact ?? '';

  return (
    <div className="sphere-timeline-event__content-block">
      <p className="sphere-timeline-event__description">
        {t('activityFeed.events.impactChanged.detail', {
          oldImpact: String(oldImpact),
          newImpact: String(newImpact),
        })}
      </p>
    </div>
  );
};

export default ImpactChangedContent;
